import type { IndexHeroSlide } from '~/src/shared/types/index-page'

const PATH_TO_IMAGES = '/images/index-page'

type HeroSlidesType = IndexHeroSlide & { background?: { desktop?: string, tablet?: string, mobile?: string } }

export const heroSlides: HeroSlidesType[] = [
    {
        id: 1,
        img: {
            desktop: `${PATH_TO_IMAGES}/hero-slider/first-slide-desktop.png`,
            tablet: `${PATH_TO_IMAGES}/hero-slider/first-slide-desktop.png`,
            mobile: `${PATH_TO_IMAGES}/hero-slider/first-slide-desktop.png`,
        },
        title: 'Поиск траффика – найдем там, где не смогут другие!',
        description: 'Попробуйте бесплатно – откройте новые каналы трафика за несколько кликов!',
        link: {
            text: 'Подробнее',
            href: '',
        },
        background: {
            desktop: 'radial-gradient(24.77% 24.92% at 83.67% 29.42%, #112834 0%, #0E1B2E 64.59%, #0C1824 100%)',
            tablet: 'radial-gradient(56.48% 53.75% at 64.99% 65.63%, #112834 0%, #0E1B2E 49.36%, #0C1824 100%)',
            mobile: 'radial-gradient(58.06% 44.96% at 55.57% 68.22%, #112834 0%, #0E1B2E 65.18%, #0C1824 100%)'
        }

    }
]
